import {SessionState} from '../state/session.state';
import {EMPTY_ID} from '../../shared/constants/empty-id';
import * as SessionActions from '../actions/session.actions';

const initialState: SessionState = {
  userId: EMPTY_ID,
  displayName: '',
  username: '',
  bearerToken: '',
  totpLocked: false,
};

export function SessionReducer(state: SessionState = initialState, action: SessionActions.Actions): SessionState {
  switch (action.type) {
    case SessionActions.USER_LOGGED_IN:
      return {
        ...state,
        displayName: action.displayName,
        userId: action.userId,
        username: action.username,
        bearerToken: action.bearerToken,
        totpLocked: action.totpLocked,
      };
    case SessionActions.USER_LOGGED_OUT:
      return {
        ...state,
        displayName: '',
        userId: EMPTY_ID,
        username: '',
        bearerToken: '',
        totpLocked: false,
      };
    default:
      return state;
  }
}
